/**
 * Platform Reports Routes - Hub and spokes pattern
 */
import { Routes, Route } from 'react-router-dom'
import { PlatformReportFavouritesProvider } from './PlatformReportFavourites'
import PlatformReportsHub from './PlatformReportsHub'
import InventoryBalanceReport from './reports/InventoryBalanceReport'
import FranchiseXeroConfigReport from './reports/FranchiseXeroConfigReport'
import ExceptionsReport from './reports/ExceptionsReport'
import OutletRegisterListReport from './reports/OutletRegisterListReport'
import XeroMissingClosureCogsBillsReport from './reports/XeroMissingClosureCogsBillsReport'
import XeroDuplicateClosureBillsReport from './reports/XeroDuplicateClosureBillsReport'
import XeroTrialBalanceReport from './reports/XeroTrialBalanceReport'
import LightspeedUserListReport from './reports/LightspeedUserListReport'
import BackdatedSalesReport from './reports/BackdatedSalesReport'
import SalesExTaxVarianceReport from './reports/SalesExTaxVarianceReport'
import ProductCatalogueReviewSummaryReport from './reports/ProductCatalogueReviewSummaryReport'
import ProductCatalogueAnalysisReport from './reports/ProductCatalogueAnalysisReport'
import SupplierPurchaseReviewReport from './reports/SupplierPurchaseReviewReport'
import CogsTrackerPage from './reports/CogsTracker/CogsTrackerPage'

export default function PlatformReportsRoutes() {
  return (
    <PlatformReportFavouritesProvider>
    <Routes>
      <Route index element={<PlatformReportsHub />} />
      <Route path="exceptions" element={<ExceptionsReport />} />
      <Route path="inventory-balance" element={<InventoryBalanceReport />} />
      <Route path="franchise-xero-config" element={<FranchiseXeroConfigReport />} />
      <Route path="outlet-register-list" element={<OutletRegisterListReport />} />
      <Route path="product-catalogue-review-summary" element={<ProductCatalogueReviewSummaryReport />} />
      <Route path="product-catalogue-analysis" element={<ProductCatalogueAnalysisReport />} />
      <Route path="xero-missing-closure-cogs-bills" element={<XeroMissingClosureCogsBillsReport />} />
      <Route path="xero-duplicate-closure-bills" element={<XeroDuplicateClosureBillsReport />} />
      <Route path="xero-trial-balance" element={<XeroTrialBalanceReport />} />
      <Route path="lightspeed-user-list" element={<LightspeedUserListReport />} />
      <Route path="backdated-sales" element={<BackdatedSalesReport />} />
      <Route path="sales-ex-tax-variance" element={<SalesExTaxVarianceReport />} />
      <Route path="supplier-purchase-review" element={<SupplierPurchaseReviewReport />} />
      <Route path="cogs-completion-monthly" element={<CogsTrackerPage />} />
    </Routes>
    </PlatformReportFavouritesProvider>
  )
}
